import { useState } from 'react';
import { isWorkspaceAdmin, useAuth } from '@/shared/auth';
import { Button } from '@/shared/components';
import { MessageSendResolutionDialog } from './MessageSendResolutionDialog';

export function MessageSendResolutionAction({ messageId }: { messageId: string }) {
  const admin = isWorkspaceAdmin(useAuth().user);
  const [open, setOpen] = useState(false);
  if (!admin) return null;
  return (
    <>
      <Button variant="link" size="sm" onClick={() => setOpen(true)}>
        Versand klären
      </Button>
      {open && <MessageSendResolutionDialog messageId={messageId} onClose={() => setOpen(false)} />}
    </>
  );
}
